import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getMyNotifications, markNotificationAsRead, markAllNotificationsRead } from '../../../services'

export const fetchNotifications = createAsyncThunk(
  'notifications/fetch',
  async () => {
    const data = await getMyNotifications()
    return data
  }
)

export const markAsRead = createAsyncThunk(
  'notifications/markAsRead',
  async (notificationId) => {
    await markNotificationAsRead(notificationId)
    return notificationId
  }
)

export const markAllAsRead = createAsyncThunk(
  'notifications/markAllAsRead',
  async () => {
    await markAllNotificationsRead()
  }
)

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    items: [],
    unreadCount: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchNotifications.pending, state => {
        state.loading = true
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false
        state.items = action.payload.notifications ?? []
        state.unreadCount = action.payload.unreadCount ?? 0
      })
      .addCase(fetchNotifications.rejected, state => {
        state.loading = false
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const id = action.payload
        const item = state.items.find(n => n.id === id)
        if (item && !item.readAt) {
          item.readAt = new Date().toISOString()
          state.unreadCount = Math.max(0, state.unreadCount - 1)
        }
      })
      .addCase(markAllAsRead.fulfilled, state => {
        state.items.forEach(n => {
          if (!n.readAt) n.readAt = new Date().toISOString()
        })
        state.unreadCount = 0
      })
  },
})

export default notificationsSlice.reducer
